// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/Assets/Feeds/backgroundImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ── Root page wrapper ── */
.AdventureDashboardPage {
  width: 100%;
  min-height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #071414;
  color: #ffffff;
  font-family: "Inter", sans-serif;
}

.adventureDashboardContainer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* ── Header ── */
.headerContain {
  z-index: 100000;
}

/* ── Body row (sidebar + content) ── */
.adventureDashboardContainer2 {
  display: flex;
  width: 100%;
  min-height: calc(100vh - 12vh);
  position: relative;
}

/* ── Sidebar ── */
.sidebarContain {
  position: fixed;
  left: 0;
  top: 0;
  width: 20%;
  height: 100vh;
  background-color: rgba(14, 27, 27, 0.95);
  padding-top: 15vh;
  z-index: 1000;
  overflow-y: auto;
  padding-left: 1.5vw;
  padding-right: 1.5vw;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.sidebarContain::-webkit-scrollbar { width: 6px; }
.sidebarContain::-webkit-scrollbar-track { background: transparent; }
.sidebarContain::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
.sidebarContain::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

/* ── Main content area ── */
.adv-db-main {
  margin-left: 22%;
  margin-right: 2%;
  margin-top: 14vh;
  margin-bottom: 3vh;
  min-height: calc(100vh - 15vh);
  width: 76%;
  z-index: 1000;
  box-sizing: border-box;
  padding: 0 0.5vw;
}

/* ── Page header text ── */
.adv-db-page-header {
  margin-bottom: 28px;
}

.adv-db-welcome {
  font-family: "Inter", sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: normal;
  margin: 0 0 8px 0;
  color: #ffffff;
}

.adv-db-highlight {
  color: #48d1cc;
}

.adv-db-sub {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #777;
  margin: 0;
  line-height: normal;
}

/* ── View-mode switcher ── */
.adv-db-switcher {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background-color: #0e1b1b;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  width: fit-content;
}

.adv-db-switch-btn {
  padding: 8px 22px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #777;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  transition: all 0.2s ease;
}

.adv-db-switch-btn--active {
  background-color: #3bb3ae;
  color: #071414;
  font-weight: 700;
}

/* ── Loading / Error states ── */
.adv-db-loading {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #777;
  padding: 60px 0;
  text-align: center;
  line-height: normal;
}

.adv-db-error {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: #ff6b6b;
  padding: 40px 0;
  text-align: center;
}

/* ── Stats grid ── */
.adv-db-stats-grid {
  display: grid;
  gap: 16px;
  margin-bottom: 24px;
}

.adv-db-stats-grid--3 { grid-template-columns: repeat(3, 1fr); }
.adv-db-stats-grid--4 { grid-template-columns: repeat(4, 1fr); }
.adv-db-stats-grid--5 { grid-template-columns: repeat(5, 1fr); }

.adv-db-stat-card {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: border-color 0.25s ease;
}

.adv-db-stat-card:hover {
  border-color: rgba(59, 179, 174, 0.35);
}

.adv-db-stat-icon {
  font-size: 22px;
  width: 46px;
  height: 46px;
  border-radius: 8px;
  background-color: rgba(59, 179, 174, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.adv-db-stat-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.adv-db-stat-title {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #777;
  line-height: normal;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.adv-db-stat-value {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  line-height: normal;
}

/* ── Sections ── */
.adv-db-section {
  margin-bottom: 32px;
}

.adv-db-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.adv-db-section-title {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  line-height: normal;
  margin: 0 0 14px 0;
}

.adv-db-section-header .adv-db-section-title {
  margin-bottom: 0;
}

.adv-db-link-btn {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #48d1cc;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: normal;
  transition: opacity 0.2s;
}

.adv-db-link-btn:hover { opacity: 0.75; }

/* ── Booking / Job list ── */
.adv-db-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adv-db-booking-card {
  display: flex;
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  transition: border-color 0.2s ease;
}

.adv-db-booking-card:hover {
  border-color: rgba(59, 179, 174, 0.3);
}

.adv-db-booking-card__left {
  display: flex;
  gap: 14px;
  align-items: center;
}

.adv-db-booking-card__img {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.adv-db-booking-card__avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.adv-db-booking-card__name {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: normal;
  margin: 0 0 4px 0;
}

.adv-db-booking-card__meta {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #777;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  line-height: normal;
}

.adv-db-booking-card__meta-text {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #777;
  margin: 2px 0 0 0;
  line-height: normal;
}

.adv-db-booking-card__meta-text strong {
  color: #ffffff;
  font-weight: 500;
}

.adv-db-booking-card__actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
}

/* ── Status badges ── */
.adv-db-status {
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;
  padding: 3px 10px;
  border-radius: 20px;
}

.adv-db-status--confirmed  { color: #48d1cc; background: rgba(72, 209, 204, 0.1); }
.adv-db-status--pending    { color: #f5c842; background: rgba(245, 200, 66, 0.1); }
.adv-db-status--in_progress { color: #ffd700; background: rgba(255, 215, 0, 0.1); }

/* ── Action buttons ── */
.adv-db-outline-btn {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  padding: 8px 18px;
  border-radius: 8px;
  border: 1px solid #484848;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
  white-space: nowrap;
}

.adv-db-outline-btn:hover {
  border-color: #48d1cc;
  color: #48d1cc;
}

.adv-db-confirm-btn {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background-color: #3bb3ae;
  color: #071414;
  cursor: pointer;
  transition: opacity 0.2s;
}

.adv-db-confirm-btn:hover { opacity: 0.88; }

.adv-db-decline-btn {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(255, 107, 107, 0.35);
  background: transparent;
  color: #ff6b6b;
  cursor: pointer;
  transition: background 0.2s;
}

.adv-db-decline-btn:hover {
  background: rgba(255, 107, 107, 0.08);
}

.adv-db-price {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #48d1cc;
  line-height: normal;
  margin-right: 4px;
}

/* ── Empty state ── */
.adv-db-empty {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 36px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.adv-db-empty p {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #777;
  margin: 0;
  line-height: normal;
}

.adv-db-empty-btn {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 22px;
  border-radius: 8px;
  border: none;
  background-color: #3bb3ae;
  color: #071414;
  cursor: pointer;
  transition: opacity 0.2s;
}

.adv-db-empty-btn:hover { opacity: 0.88; }

/* ── Responsive ── */
@media (max-width: 1280px) {
  .adv-db-stats-grid--5 { grid-template-columns: repeat(2, 1fr); }
  .adv-db-stats-grid--4 { grid-template-columns: repeat(2, 1fr); }
  .adv-db-stats-grid--3 { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .adv-db-main {
    margin-left: 0;
    margin-right: 0;
    margin-top: 80px;
    width: 100%;
    padding: 0 16px;
  }

  .sidebarContain {
    display: none;
  }

  .adv-db-stats-grid--3,
  .adv-db-stats-grid--4,
  .adv-db-stats-grid--5 {
    grid-template-columns: 1fr;
  }

  .adv-db-booking-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .adv-db-booking-card__actions {
    width: 100%;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/AdventureDashboardPage/AdventureDashboardPage.css"],"names":[],"mappings":";AAGA,4BAA4B;AAC5B;EACE,WAAW;EACX,iBAAiB;EACjB,yDAAuE;EACvE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,UAAU;EACV,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,uBAAuB,EAAE;AACpE;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,wBAAwB,qCAAqC,EAAE;AAC/D,wBAAwB,qCAAqC,EAAE;AAC/D,wBAAwB,qCAAqC,EAAE;;AAE/D;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,yBAAyB,aAAa,EAAE;;AAExC,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,6BAA6B,cAAc,EAAE,mCAAmC,EAAE;AAClF,6BAA6B,cAAc,EAAE,mCAAmC,EAAE;AAClF,8BAA8B,cAAc,EAAE,kCAAkC,EAAE;;AAElF,yBAAyB;AACzB;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA,4BAA4B,aAAa,EAAE;;AAE3C;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA,0BAA0B,aAAa,EAAE;;AAEzC,qBAAqB;AACrB;EACE,wBAAwB,qCAAqC,EAAE;EAC/D,wBAAwB,qCAAqC,EAAE;EAC/D,wBAAwB,qCAAqC,EAAE;AACjE;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":["\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n/* ── Root page wrapper ── */\n.AdventureDashboardPage {\n  width: 100%;\n  min-height: 100vh;\n  background-image: url(\"../../../public/Assets/Feeds/backgroundImg.svg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #071414;\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n}\n\n.adventureDashboardContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* ── Header ── */\n.headerContain {\n  z-index: 100000;\n}\n\n/* ── Body row (sidebar + content) ── */\n.adventureDashboardContainer2 {\n  display: flex;\n  width: 100%;\n  min-height: calc(100vh - 12vh);\n  position: relative;\n}\n\n/* ── Sidebar ── */\n.sidebarContain {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 20%;\n  height: 100vh;\n  background-color: rgba(14, 27, 27, 0.95);\n  padding-top: 15vh;\n  z-index: 1000;\n  overflow-y: auto;\n  padding-left: 1.5vw;\n  padding-right: 1.5vw;\n  box-sizing: border-box;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n.sidebarContain::-webkit-scrollbar { width: 6px; }\n.sidebarContain::-webkit-scrollbar-track { background: transparent; }\n.sidebarContain::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 3px;\n}\n.sidebarContain::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n/* ── Main content area ── */\n.adv-db-main {\n  margin-left: 22%;\n  margin-right: 2%;\n  margin-top: 14vh;\n  margin-bottom: 3vh;\n  min-height: calc(100vh - 15vh);\n  width: 76%;\n  z-index: 1000;\n  box-sizing: border-box;\n  padding: 0 0.5vw;\n}\n\n/* ── Page header text ── */\n.adv-db-page-header {\n  margin-bottom: 28px;\n}\n\n.adv-db-welcome {\n  font-family: \"Inter\", sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0 0 8px 0;\n  color: #ffffff;\n}\n\n.adv-db-highlight {\n  color: #48d1cc;\n}\n\n.adv-db-sub {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #777;\n  margin: 0;\n  line-height: normal;\n}\n\n/* ── View-mode switcher ── */\n.adv-db-switcher {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  background-color: #0e1b1b;\n  padding: 6px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  width: fit-content;\n}\n\n.adv-db-switch-btn {\n  padding: 8px 22px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: #777;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  transition: all 0.2s ease;\n}\n\n.adv-db-switch-btn--active {\n  background-color: #3bb3ae;\n  color: #071414;\n  font-weight: 700;\n}\n\n/* ── Loading / Error states ── */\n.adv-db-loading {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #777;\n  padding: 60px 0;\n  text-align: center;\n  line-height: normal;\n}\n\n.adv-db-error {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  color: #ff6b6b;\n  padding: 40px 0;\n  text-align: center;\n}\n\n/* ── Stats grid ── */\n.adv-db-stats-grid {\n  display: grid;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.adv-db-stats-grid--3 { grid-template-columns: repeat(3, 1fr); }\n.adv-db-stats-grid--4 { grid-template-columns: repeat(4, 1fr); }\n.adv-db-stats-grid--5 { grid-template-columns: repeat(5, 1fr); }\n\n.adv-db-stat-card {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  transition: border-color 0.25s ease;\n}\n\n.adv-db-stat-card:hover {\n  border-color: rgba(59, 179, 174, 0.35);\n}\n\n.adv-db-stat-icon {\n  font-size: 22px;\n  width: 46px;\n  height: 46px;\n  border-radius: 8px;\n  background-color: rgba(59, 179, 174, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.adv-db-stat-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.adv-db-stat-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #777;\n  line-height: normal;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.adv-db-stat-value {\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: normal;\n}\n\n/* ── Sections ── */\n.adv-db-section {\n  margin-bottom: 32px;\n}\n\n.adv-db-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.adv-db-section-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: normal;\n  margin: 0 0 14px 0;\n}\n\n.adv-db-section-header .adv-db-section-title {\n  margin-bottom: 0;\n}\n\n.adv-db-link-btn {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #48d1cc;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  line-height: normal;\n  transition: opacity 0.2s;\n}\n\n.adv-db-link-btn:hover { opacity: 0.75; }\n\n/* ── Booking / Job list ── */\n.adv-db-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adv-db-booking-card {\n  display: flex;\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  padding: 16px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  transition: border-color 0.2s ease;\n}\n\n.adv-db-booking-card:hover {\n  border-color: rgba(59, 179, 174, 0.3);\n}\n\n.adv-db-booking-card__left {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n}\n\n.adv-db-booking-card__img {\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.adv-db-booking-card__avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.adv-db-booking-card__name {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  line-height: normal;\n  margin: 0 0 4px 0;\n}\n\n.adv-db-booking-card__meta {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #777;\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n  line-height: normal;\n}\n\n.adv-db-booking-card__meta-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: #777;\n  margin: 2px 0 0 0;\n  line-height: normal;\n}\n\n.adv-db-booking-card__meta-text strong {\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.adv-db-booking-card__actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* ── Status badges ── */\n.adv-db-status {\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: normal;\n  text-transform: capitalize;\n  padding: 3px 10px;\n  border-radius: 20px;\n}\n\n.adv-db-status--confirmed  { color: #48d1cc; background: rgba(72, 209, 204, 0.1); }\n.adv-db-status--pending    { color: #f5c842; background: rgba(245, 200, 66, 0.1); }\n.adv-db-status--in_progress { color: #ffd700; background: rgba(255, 215, 0, 0.1); }\n\n/* ── Action buttons ── */\n.adv-db-outline-btn {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  padding: 8px 18px;\n  border-radius: 8px;\n  border: 1px solid #484848;\n  background: transparent;\n  color: #ffffff;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease;\n  white-space: nowrap;\n}\n\n.adv-db-outline-btn:hover {\n  border-color: #48d1cc;\n  color: #48d1cc;\n}\n\n.adv-db-confirm-btn {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  background-color: #3bb3ae;\n  color: #071414;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.adv-db-confirm-btn:hover { opacity: 0.88; }\n\n.adv-db-decline-btn {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 107, 107, 0.35);\n  background: transparent;\n  color: #ff6b6b;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.adv-db-decline-btn:hover {\n  background: rgba(255, 107, 107, 0.08);\n}\n\n.adv-db-price {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #48d1cc;\n  line-height: normal;\n  margin-right: 4px;\n}\n\n/* ── Empty state ── */\n.adv-db-empty {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  padding: 36px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.adv-db-empty p {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #777;\n  margin: 0;\n  line-height: normal;\n}\n\n.adv-db-empty-btn {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 10px 22px;\n  border-radius: 8px;\n  border: none;\n  background-color: #3bb3ae;\n  color: #071414;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.adv-db-empty-btn:hover { opacity: 0.88; }\n\n/* ── Responsive ── */\n@media (max-width: 1280px) {\n  .adv-db-stats-grid--5 { grid-template-columns: repeat(2, 1fr); }\n  .adv-db-stats-grid--4 { grid-template-columns: repeat(2, 1fr); }\n  .adv-db-stats-grid--3 { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 768px) {\n  .adv-db-main {\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 80px;\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .sidebarContain {\n    display: none;\n  }\n\n  .adv-db-stats-grid--3,\n  .adv-db-stats-grid--4,\n  .adv-db-stats-grid--5 {\n    grid-template-columns: 1fr;\n  }\n\n  .adv-db-booking-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .adv-db-booking-card__actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
